// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"24":"2fe87e77","253":"aefe8090"}[chunkId] + ".css";
};